<template>
  <div>
    <v-card-widget title="Dashboard">
      <div slot="widget-content">
        <app-timeline :itens="timelineItens" />
      </div>
    </v-card-widget>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';
import AppTimeline from '@/components/core/AppTimeline';

export default {
  name: 'DashboardMonitoramento',

  components: { VCardWidget, AppTimeline },

  data() {
    return {
      timelineItens: [
        {
          visibilidade: true,
          titulo: 'Monitoramento do Perfil',
          textos: [
            'Como Gestor você pode acompanhar os resultados da etapa Perfil.',
          ],
          icone: 'person',
          link: '/monitoramento/perfil',
        },
        {
          visibilidade: true,
          titulo: 'Monitoramento do Mapeamento',
          textos: [
            'Como Gestor você pode acompanhar os resultados da etapa Mapeamento: comportamental e técnico.',
          ],
          icone: 'widgets',
          link: '/monitoramento/mapeamento',
        },
        {
          visibilidade: true,
          titulo: 'Monitoramento do Diagnóstico',
          textos: [
            'Como Gestor você pode acompanhar os resultados da etapa Diagnóstico: comportamental e técnico.',
          ],
          icone: 'how_to_reg',
          link: '/monitoramento/diagnostico',
        },
        {
          visibilidade: true,
          titulo: 'Monitoramento do Desempenho',
          textos: [
            'Como Gestor você pode acompanhar os resultados da etapa Desempenho: comportamental, '
            + 'técnico e do CDS.',
          ],
          icone: 'trending_up',
          link: '/monitoramento/desempenho',
        },
      ],
    };
  },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
    }),
  },

  created() {
    if (!this.comissao && !this.chefia && !this.substituicaoChefia) {
      this.$router.push('/403');
    }
  },
};
</script>
